module.exports = __webpack_public_path__ + "img/lottery_768.00b4009e.png";